module.exports = __webpack_public_path__ + "static/media/use13_jpn.05816055.png";